export const AllLeads = () => {
  return <div>AllLeads</div>;
};
